"use strict";
// SPDX-FileCopyrightText: 2024 Red Bee Media Ltd <https://www.redbeemedia.com/>
//
// SPDX-License-Identifier: MIT
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitmovinPlayerError = exports.ShakaPlayerError = exports.HlsJsPlayerError = exports.DashJsPlayerError = exports.InitError = exports.UserError = exports.APIError = exports.PlayerError = exports.ErrorTypes = void 0;
exports.ErrorTypes = {
    GENERIC: "GENERIC",
    OPTIONS: "INIT_OPTIONS",
    ABORTED: "ABORTED",
    API_AUTH: "AUTH_FAILED",
    API_AUTH_ANON: "AUTH_ANON_FAILED",
    API_PLAY_REQUEST: "PLAY_REQUEST_FAILED",
    API_ASSET: "ASSET_REQUEST_FAILED",
    DECODE: "DECODE_ERROR",
    DRM: "DRM_ERROR",
    NETWORK: "NETWORK_ERROR",
    STREAM_NOT_AVAILABLE: "STREAM_NOT_AVAILABLE",
    STREAM_LIMIT: "STREAM_LIMIT_REACHED",
    NOT_AUTHENTICATED: "SESSION_NOT_AUTHENTICATED",
    NOT_AUTHORIZED: "UNAUTHORIZED",
    GEO_LOCATION: "GEOLOCATION",
    MANIFEST: "MANIFEST_ERROR",
    SEGMENT: "SEGMENT_ERROR",
    MEDIA: "MEDIA_ERROR",
    CODEC: "CODEC",
    CAST: "CAST",
    PLAYER_ENGINE: "GENERIC_PLAYERENGINE_ERROR",
    UNSUPPORTED_DEVICE: "UNSUPPORTED_DEVICE",
    UNSUPPORTED_SCREEN: "UNSUPPORTED_SCREEN",
    OTHER: "OTHER_ERROR",
    DESTROYED: "DESTROYED",
    SRC_NOT_SUPPORTED: "SOURCE_NOT_SUPPORTED",
};
class PlayerError extends Error {
    constructor(message, { type, code, rawError }) {
        super(message);
        this.category = "PLAYER";
        this.message = message;
        this.metadata = Object.assign(Object.assign({ type }, (Number.isFinite(code) && { code })), (rawError && { rawError }));
    }
    toString() {
        const metadataString = Object.entries(this.metadata)
            .filter(([type]) => type !== "rawError")
            .map((pair) => pair.join(": "))
            .join(", ");
        return `${this.category} Error: ${this.message} {${metadataString}}`;
    }
}
exports.PlayerError = PlayerError;
class APIError extends PlayerError {
    constructor() {
        super(...arguments);
        this.category = "API";
    }
}
exports.APIError = APIError;
class UserError extends PlayerError {
    constructor() {
        super(...arguments);
        this.category = "USER";
    }
}
exports.UserError = UserError;
class InitError extends PlayerError {
    constructor() {
        super(...arguments);
        this.category = "INIT";
    }
}
exports.InitError = InitError;
class DashJsPlayerError extends PlayerError {
    constructor() {
        super(...arguments);
        this.category = "DASHJS";
    }
}
exports.DashJsPlayerError = DashJsPlayerError;
class HlsJsPlayerError extends PlayerError {
    constructor() {
        super(...arguments);
        this.category = "HLSJS";
    }
}
exports.HlsJsPlayerError = HlsJsPlayerError;
class ShakaPlayerError extends PlayerError {
    constructor() {
        super(...arguments);
        this.category = "SHAKAPLAYER";
    }
}
exports.ShakaPlayerError = ShakaPlayerError;
class BitmovinPlayerError extends PlayerError {
    constructor() {
        super(...arguments);
        this.category = "BITMOVIN";
    }
}
exports.BitmovinPlayerError = BitmovinPlayerError;
//# sourceMappingURL=error.js.map